import React, { ReactNode, useMemo } from 'react';

import { IQuestion } from '../../../modules/survey/survey.types';
import { ISliderControlProps, SliderControl } from './slider.control';

export interface IGetControlForQuestionParams {
  question: IQuestion;
  onChange?: ISliderControlProps['onChange'];
}

export const useGetControlForQuestion = ({ question, onChange }: IGetControlForQuestionParams): ReactNode | null => {
  return useMemo(() => {
    return question.type === 'slider' ? (
      <SliderControl
        min={question.min}
        max={question.max}
        name={question.name}
        measurement={question.measurement}
        onChange={onChange}
      />
    ) : null;
  }, [onChange, question.max, question.measurement, question.min, question.name, question.type]);
};
